import * as React from "react";
import { isDocumentHidden, onVisibilityChange, removeOnVisibilityChangeHandler } from "../../../../lib/browser-hacks";
import { standalone } from "../../../lib/device";
import VideoPlayerView from "../../views/video-player/video-player-view";
import { browserMightBeOniOS } from "lib/browser-detect";

interface Props {
    readonly url: string;
    readonly className?: string;
}

const VideoPlayer: React.FunctionComponent<Props> = props => {
    const [shouldPlay, setShouldPlay] = React.useState(true);

    const visChangedHandler = React.useCallback(() => {
        if (browserMightBeOniOS && standalone) {
            setShouldPlay(!isDocumentHidden());
        }
    }, []);

    React.useEffect(() => {
        onVisibilityChange(visChangedHandler);

        return function unmount() {
            removeOnVisibilityChangeHandler(visChangedHandler);
        };
    }, [visChangedHandler]);

    return <VideoPlayerView shouldPlay={shouldPlay} {...props} />;
};

export default VideoPlayer;
